import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '1.5rem',
    height: '1.5rem',
    fill: 'white',
  },
});

const ReturnIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon}>
      <path
        d="M17.9183 21.8182H11.3729C11.0835 21.8182 10.8061 21.9331 10.6015 22.1377C10.3969 22.3423 10.2819 22.6198 10.2819 22.9091C10.2819 23.1984 10.3969 23.4759 10.6015 23.6805C10.8061 23.8851 11.0835 24 11.3729 24H17.9183C18.7863 24 19.6187 23.6552 20.2325 23.0414C20.8462 22.4277 21.191 21.5953 21.191 20.7273V3.27273C21.191 2.40475 20.8462 1.57232 20.2325 0.95856C19.6187 0.344804 18.7863 0 17.9183 0H11.3729C11.0835 0 10.8061 0.114935 10.6015 0.31952C10.3969 0.524105 10.2819 0.801582 10.2819 1.09091C10.2819 1.38024 10.3969 1.65771 10.6015 1.8623C10.8061 2.06688 11.0835 2.18182 11.3729 2.18182H17.9183C18.2076 2.18182 18.4851 2.29675 18.6897 2.50134C18.8943 2.70592 19.0092 2.9834 19.0092 3.27273V20.7273C19.0092 21.0166 18.8943 21.2941 18.6897 21.4987C18.4851 21.7032 18.2076 21.8182 17.9183 21.8182ZM2.96193 11.2255C2.86262 11.3292 2.78476 11.4516 2.73284 11.5855C2.62373 11.8511 2.62373 12.149 2.73284 12.4146C2.78476 12.5485 2.86262 12.6708 2.96193 12.7746L7.32557 17.1382C7.42698 17.2404 7.54764 17.3216 7.68058 17.377C7.81351 17.4324 7.9561 17.4609 8.10011 17.4609C8.24413 17.4609 8.38671 17.4324 8.51965 17.377C8.65259 17.3216 8.77325 17.2404 8.87466 17.1382C8.97691 17.0368 9.05807 16.9161 9.11345 16.7832C9.16883 16.6503 9.19735 16.5077 9.19735 16.3637C9.19735 16.2196 9.16883 16.0771 9.11345 15.9441C9.05807 15.8112 8.97691 15.6905 8.87466 15.5891L6.36557 13.0909H13.5547C13.844 13.0909 14.1215 12.976 14.326 12.7714C14.5306 12.5668 14.6456 12.2893 14.6456 12C14.6456 11.7107 14.5306 11.4332 14.326 11.2286C14.1215 11.024 13.844 10.9091 13.5547 10.9091H6.36557L8.87466 8.41093C9.08008 8.20551 9.19549 7.92689 9.19549 7.63638C9.19549 7.49254 9.16715 7.3501 9.11211 7.2172C9.05706 7.0843 8.97637 6.96355 8.87466 6.86184C8.66924 6.65641 8.39062 6.54101 8.10011 6.54101C7.95627 6.54101 7.81383 6.56934 7.68093 6.62439C7.54804 6.67944 7.42728 6.76012 7.32557 6.86184L2.96193 11.2255Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </SvgIcon>
  );
};

export default memo(ReturnIcon);
